// src/components/ForgotPassword.js
import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import authBg from "../../assets/images/big/auth-bg.jpg";
import $ from "jquery";
import Swal from "sweetalert2";
import { sendmemberresetpasswordlink } from "../../store/slices/userSlice";
import { useFormik } from "formik";
import { createFormData } from "../../utils/common";
import * as Yup from "yup";
import { useDispatch } from "react-redux";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    $(".preloader").fadeOut();
  }, []);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => { // Made onSubmit async
      setSubmitting(true); // Set submitting to true at the start
      try {
        const res = await dispatch(sendmemberresetpasswordlink(createFormData(values))).unwrap();
        console.log(res);

        if (res.status === 200) {
          Swal.fire("Success", "Reset Password Mail Sent Successfully!", "success");
          navigate("/");
        } else {
          Swal.fire("Error", "Email not registered", "error");
        }
      } catch (error) {
        console.error("Reset link failed:", error);
        // Check if the error has a response and data to get a more specific message
        Swal.fire("Error", error?.response?.data?.message || "Something went wrong. Please try again.", "error");
      } finally {
        setSubmitting(false); // Ensure submitting is set to false in all cases
      }
    },
  });

  return (
    <div className="main-wrapper">
      <div className="preloader">
        <div className="lds-ripple">
          <div className="lds-pos"></div>
          <div className="lds-pos"></div>
        </div>
      </div>
      <div
        className="auth-wrapper d-flex no-block justify-content-center align-items-center position-relative"
        style={{ background: `url(${authBg}) no-repeat center center` }}
      >
        <div className="auth-box row d-flex no-block justify-content-center align-items-center ">
          <div className="col-lg-8 col-md-12 bg-white">
            <div className="p-3">
              <div className="text-center">Forgot Password</div>
              <h2 className="mt-3 text-center">Reset Your Password</h2>

              <form className="mt-4" onSubmit={formik.handleSubmit}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group mb-3">
                      <label className="form-label text-dark" htmlFor="email">
                        Email Address
                      </label>
                      <input
                        className={`form-control ${formik.touched.email && formik.errors.email ? "is-invalid" : ""
                          }`}
                        type="email"
                        id="email"
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.email && formik.errors.email ? (
                        <div className="invalid-feedback">{formik.errors.email}</div>
                      ) : null}
                    </div>
                  </div>

                  <div className="col-lg-12 text-center">
                    <button type="submit" className="btn w-100 btn-dark" disabled={formik.isSubmitting}>
                      {formik.isSubmitting ? "Submitting..." : "Submit"}
                    </button>
                  </div>

                  <div className="col-lg-12 text-center mt-5">
                    <Link to="/">Back to Login</Link>
                  </div>
                  <div className="col-lg-12 text-center mt-2">
                    Don&apos;t have an account?{" "}
                    <Link to="/register" className="text-danger">
                      Sign Up
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;